module.exports = __webpack_public_path__ + "media/bootstrap-icons/trash2-fill-8e11048b.svg";